import React, {forwardRef} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TStateSetter} from 'shared/types/generics';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectUserInfo} from 'store/slices/auth-slice';
import {clearStageThunk} from 'store/slices/external-loading/external-loading-thunks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';

import styles from './clear-stage-modal.module.css';

interface IClearStageConfirmationModalProps {
    loadId: number | undefined;
    resetState: () => void;
}

export const ClearStageModal = forwardRef<IModalOpenerComponentRef, IClearStageConfirmationModalProps>((
    {loadId, resetState}: IClearStageConfirmationModalProps,
    ref,
) => {
    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo);
    const userName = userInfo?.userName || '';

    const isClearing = useAppSelector(s => selectIsThunkPending(s, clearStageThunk.typePrefix));

    const handleClear = (setIsModalOpen: TStateSetter<boolean>) => {
        if (!loadId) return;

        showMessage({message: 'Очистка stage-области запущена.'});
        dispatch(clearStageThunk({userName, loadId})).unwrap().then(() => {
            showMessage({message: 'Stage-область очищена.'});
            resetState();
        }).catch(() => {
            showMessage({message: 'Во время очистки stage-области произошла ошибка', isError: true});
        });
        setIsModalOpen(false);
    };

    return (
        <ModalOpenerComponent
            ref={ref}
            modalProps={{
                forceRender: false,
                destroyOnClose: true,
                title: 'Подтверждение операции',
                centered: true,
                width: 800,
            }}
            controlLabels={{
                save: 'Да',
                cancel: 'Нет',
            }}
            loadingControls={{
                save: isClearing,
            }}
            disabledControls={{
                save: isClearing,
            }}
            handleSave={setIsModalOpen => {
                handleClear(setIsModalOpen);
            }}
        >
            <div className={styles.confirmationText}>
                Вы уверены, что хотите очистить stage-область?
            </div>
            <div className={styles.noteText}>
                <b>Примечание:</b> По данному сценарию и идентификатору загрузки не было запуска сценариев загрузки.
                После подтверждения операции данные будут удалены безвозвратно.
            </div>
        </ModalOpenerComponent>
    );
});
